import { SboCurrency, SportType } from '@/interface/enum';

const defaultSportsOrder = [
    SportType.Soccer,
    SportType.FantasySelection,
    SportType.VirtualFootball,
    SportType.Basketball,
    SportType.VirtualBasketball,
    SportType.Badminton,
    SportType.Tennis,
    SportType.Volleyball,
    SportType.EsportsForDisplay,
    SportType.Esports,
    SportType.TableTennis,
    SportType.Football,
    SportType.Baseball,
    SportType.Pool,
    SportType.IceHockey,
    SportType.Golf,
    SportType.Olympic,
    SportType.MuayThaiForDisplay,
    SportType.MuayThai,
    SportType.Rugby,
    SportType.MixedMartialArts,
    SportType.Handball,
    SportType.MotorSport,
    SportType.Futsal,
    SportType.Cricket,
    SportType.Darts,
    SportType.Boxing,
    SportType.BeachVolleyball,
    SportType.AussieRulesFootball,
    SportType.GeneralHockey,
    SportType.WaterPolo,
    SportType.WinterSports,
    SportType.Bandy,
    SportType.Cycling,
    SportType.Athletics,
    SportType.Squash,
    SportType.WinterOlympic,
    SportType.BeachSoccer,
    SportType.Others,
    SportType.Hurling,
    SportType.GaelicFootball,
    SportType.Entertainment,
    SportType.Lacrosse,
];
const sportsOrderMap: Partial<Record<SboCurrency, SportType[]>> = {
    [SboCurrency.VND]: [
        SportType.Soccer,
        SportType.FantasySelection,
        SportType.VirtualFootball,
        SportType.Basketball,
        SportType.VirtualBasketball,
        SportType.Tennis,
        SportType.Badminton,
        SportType.EsportsForDisplay,
        SportType.Esports,
        SportType.Volleyball,
        SportType.TableTennis,
        SportType.Baseball,
        SportType.IceHockey,
        SportType.Football,
        SportType.Futsal,
        SportType.Pool,
        SportType.MotorSport,
        SportType.Golf,
        SportType.Olympic,
        SportType.Handball,
        SportType.Cricket,
        SportType.MuayThaiForDisplay,
        SportType.MuayThai,
        SportType.WaterPolo,
        SportType.Athletics,
        SportType.GeneralHockey,
        SportType.Cycling,
        SportType.Boxing,
        SportType.MixedMartialArts,
        SportType.Bandy,
        SportType.Darts,
        SportType.BeachVolleyball,
        SportType.BeachSoccer,
        SportType.AussieRulesFootball,
        SportType.Rugby,
        SportType.WinterSports,
        SportType.Squash,
        SportType.WinterOlympic,
        SportType.Others,
        SportType.Hurling,
        SportType.GaelicFootball,
        SportType.Entertainment,
        SportType.Lacrosse,
    ],
    [SboCurrency.TB]: [
        SportType.Soccer,
        SportType.FantasySelection,
        SportType.VirtualFootball,
        SportType.Basketball,
        SportType.VirtualBasketball,
        SportType.Badminton,
        SportType.Tennis,
        SportType.Volleyball,
        SportType.MuayThaiForDisplay,
        SportType.MuayThai,
        SportType.TableTennis,
        SportType.EsportsForDisplay,
        SportType.Esports,
        SportType.Pool,
        SportType.Baseball,
        SportType.IceHockey,
        SportType.Football,
        SportType.Cricket,
        SportType.Rugby,
        SportType.Golf,
        SportType.Olympic,
        SportType.MixedMartialArts,
        SportType.Handball,
        SportType.MotorSport,
        SportType.Futsal,
        SportType.BeachVolleyball,
        SportType.Boxing,
        SportType.Darts,
        SportType.AussieRulesFootball,
        SportType.Squash,
        SportType.BeachSoccer,
        SportType.GeneralHockey,
        SportType.WaterPolo,
        SportType.Bandy,
        SportType.Cycling,
        SportType.WinterSports,
        SportType.Athletics,
        SportType.WinterOlympic,
        SportType.Others,
        SportType.Hurling,
        SportType.GaelicFootball,
        SportType.Entertainment,
        SportType.Lacrosse,
    ],
    [SboCurrency.PP]: [
        SportType.Soccer,
        SportType.FantasySelection,
        SportType.VirtualFootball,
        SportType.Basketball,
        SportType.VirtualBasketball,
        SportType.Badminton,
        SportType.Tennis,
        SportType.Volleyball,
        SportType.EsportsForDisplay,
        SportType.Esports,
        SportType.TableTennis,
        SportType.Football,
        SportType.Baseball,
        SportType.IceHockey,
        SportType.MixedMartialArts,
        SportType.MotorSport,
        SportType.Golf,
        SportType.Olympic,
        SportType.Pool,
        SportType.Rugby,
        SportType.MuayThaiForDisplay,
        SportType.MuayThai,
        SportType.Futsal,
        SportType.Handball,
        SportType.AussieRulesFootball,
        SportType.Boxing,
        SportType.BeachVolleyball,
        SportType.Cricket,
        SportType.Darts,
        SportType.BeachSoccer,
        SportType.WaterPolo,
        SportType.Bandy,
        SportType.GeneralHockey,
        SportType.Cycling,
        SportType.Athletics,
        SportType.WinterSports,
        SportType.Squash,
        SportType.WinterOlympic,
        SportType.Others,
        SportType.Hurling,
        SportType.GaelicFootball,
        SportType.Entertainment,
        SportType.Lacrosse,
    ],
    [SboCurrency.KRW]: [
        SportType.Soccer,
        SportType.FantasySelection,
        SportType.VirtualFootball,
        SportType.Basketball,
        SportType.VirtualBasketball,
        SportType.Tennis,
        SportType.Baseball,
        SportType.Volleyball,
        SportType.EsportsForDisplay,
        SportType.Esports,
        SportType.Badminton,
        SportType.IceHockey,
        SportType.Handball,
        SportType.Pool,
        SportType.TableTennis,
        SportType.Football,
        SportType.MixedMartialArts,
        SportType.Rugby,
        SportType.MuayThaiForDisplay,
        SportType.MuayThai,
        SportType.Futsal,
        SportType.Cricket,
        SportType.Golf,
        SportType.Olympic,
        SportType.MotorSport,
        SportType.Darts,
        SportType.Boxing,
        SportType.BeachVolleyball,
        SportType.AussieRulesFootball,
        SportType.GeneralHockey,
        SportType.WaterPolo,
        SportType.WinterSports,
        SportType.Bandy,
        SportType.Cycling,
        SportType.Athletics,
        SportType.Squash,
        SportType.BeachSoccer,
        SportType.WinterOlympic,
        SportType.Others,
        SportType.Hurling,
        SportType.GaelicFootball,
        SportType.Entertainment,
        SportType.Lacrosse,
    ],
    [SboCurrency.INR]: [
        SportType.Cricket,
        SportType.Soccer,
        SportType.FantasySelection,
        SportType.VirtualFootball,
        SportType.Tennis,
        SportType.Basketball,
        SportType.VirtualBasketball,
        SportType.Badminton,
        SportType.Volleyball,
        SportType.EsportsForDisplay,
        SportType.Esports,
        SportType.TableTennis,
        SportType.Football,
        SportType.Baseball,
        SportType.MuayThaiForDisplay,
        SportType.MuayThai,
        SportType.Golf,
        SportType.Olympic,
        SportType.Pool,
        SportType.IceHockey,
        SportType.Rugby,
        SportType.MixedMartialArts,
        SportType.Handball,
        SportType.MotorSport,
        SportType.Darts,
        SportType.Boxing,
        SportType.BeachVolleyball,
        SportType.AussieRulesFootball,
        SportType.GeneralHockey,
        SportType.WaterPolo,
        SportType.Futsal,
        SportType.WinterSports,
        SportType.Bandy,
        SportType.Cycling,
        SportType.Athletics,
        SportType.Squash,
        SportType.BeachSoccer,
        SportType.WinterOlympic,
        SportType.Others,
        SportType.Hurling,
        SportType.GaelicFootball,
        SportType.Entertainment,
        SportType.Lacrosse,
    ],
};

export function getDefaultSportsOrder() {
    return [...defaultSportsOrder];
}

export function getSportsOrderMap() {
    return { ...sportsOrderMap };
}
